import React, { useState } from 'react';
import { Button } from '../ui';
import { TOOLBAR_ICONS } from '../toolbar/ToolbarIcons';

/**
 * EditMenu - Dropdown menu for edit operations
 */
const EditMenu = ({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  onSelectAll,
  onDeselectAll,
  onDelete,
  onDetectRooms,
  hasSelection = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { label: 'Undo', Icon: TOOLBAR_ICONS.undo, action: () => { onUndo?.(); setIsOpen(false); }, disabled: !canUndo },
    { label: 'Redo', Icon: TOOLBAR_ICONS.redo, action: () => { onRedo?.(); setIsOpen(false); }, disabled: !canRedo },
    { divider: true },
    { label: 'Select All', Icon: TOOLBAR_ICONS.selectAll || TOOLBAR_ICONS.select, action: () => { onSelectAll?.(); setIsOpen(false); } },
    { label: 'Deselect All', Icon: TOOLBAR_ICONS.pointer, action: () => { onDeselectAll?.(); setIsOpen(false); } },
    { label: 'Delete Selected', Icon: TOOLBAR_ICONS.delete, action: () => { onDelete?.(); setIsOpen(false); }, disabled: !hasSelection },
    { divider: true },
    { label: 'Detect Rooms', Icon: TOOLBAR_ICONS.room || TOOLBAR_ICONS.layers, action: () => { onDetectRooms?.(); setIsOpen(false); } },
  ];

  return (
    <div style={{ position: 'relative' }}>
      <Button
        variant="default"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <span>Edit</span>
        <span style={{ fontSize: '10px' }}>▼</span>
      </Button>

      {isOpen && (
        <>
          {/* Backdrop to close menu */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 99,
            }}
            onClick={() => setIsOpen(false)}
          />

          {/* Menu dropdown - opens upward since we're in status bar at bottom */}
          <div
            style={{
              position: 'absolute',
              bottom: '100%',
              left: 0,
              marginBottom: '4px',
              background: 'rgba(15,20,28,0.98)',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '8px',
              boxShadow: '0 -8px 32px rgba(0,0,0,0.5)',
              minWidth: '180px',
              zIndex: 100,
              overflow: 'hidden',
            }}
          >
            {menuItems.map((item, index) => (
              item.divider ? (
                <div
                  key={index}
                  style={{
                    height: '1px',
                    background: 'rgba(255,255,255,0.1)',
                    margin: '4px 0',
                  }}
                />
              ) : (
                <button
                  key={index}
                  onClick={item.disabled ? undefined : item.action}
                  disabled={item.disabled}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    width: '100%',
                    padding: '10px 14px',
                    background: 'transparent',
                    border: 'none',
                    color: item.disabled ? '#506070' : '#c0d0e0',
                    fontSize: '13px',
                    textAlign: 'left',
                    cursor: item.disabled ? 'default' : 'pointer',
                    transition: 'background 0.15s',
                    opacity: item.disabled ? 0.5 : 1,
                  }}
                  onMouseEnter={(e) => !item.disabled && (e.currentTarget.style.background = 'rgba(0,200,255,0.15)')}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                >
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    {item.Icon && <item.Icon color={item.disabled ? '#506070' : '#8090a0'} />}
                  </span>
                  <span>{item.label}</span>
                </button>
              )
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default EditMenu;
